// Rename to IntentMilestons
export enum OnboardingIntentStep {
  Welcome = 'Welcome',
  Register = 'Register',
  Newsletter = 'Newsletter',
  Caution = 'Caution',
  Check = 'Check',
  DownloadAfterCheck = 'DownloadAfterCheck',
  Login = 'Login',
  Onboarding = 'Onboarding',
  DownloadAfterOnBoarding = 'DownloadAfterOnBoarding',
  PushNotifications = 'PushNotifications',
  Claim = 'Claim',
  Consent = 'Consent',
  Sample = 'Sample',
  Complete = 'Complete',
  End = 'End',
}

export enum OnboardingType {
  DNA = 'dna',
  BLOOD = 'blood',
  LAB = 'lab',
  NIPT = 'nipt',
}
